export const sizeImageUrl = (imageUrl: string, size: number) => {
  return imageUrl.replace(/(\.[a-zA-Z]+)(\?.*)?$/, `_${size}x${size}$1$2`)
}
